import {
  AccountCreated,
  Funds,
  HelpBuildYourBusiness,
  ItemManagement,
  SIMCard,
  SomethingWentWrong,
  TapToPayIphone,
  useIsMobileResolution,
  UserAdded,
} from '@npco/zeller-design-system'

export const useGetIllustrationFromName = (name: string) => {
  const isMobile = useIsMobileResolution()
  const illustrationSize = isMobile ? 'medium' : 'large'

  switch (name) {
    case 'AccountCreated':
      return <AccountCreated size={illustrationSize} />
    case 'Funds':
      return (
        <Funds size={illustrationSize} variant="outlined-blue" alt="funds" />
      )
    case 'HelpBuildYourBusiness':
      return <HelpBuildYourBusiness size={illustrationSize} />
    case 'ItemManagement':
      return <ItemManagement size={illustrationSize} />
    case 'SimCard':
      return <SIMCard size={illustrationSize} />
    case 'SomethingWentWrong':
      return <SomethingWentWrong size={illustrationSize} />
    case 'TapToPayIphone':
      return <TapToPayIphone size={illustrationSize} />
    case 'UserAdded':
      return <UserAdded size={illustrationSize} />
    default:
      return <AccountCreated size={illustrationSize} />
  }
}
